import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getBudgetSurvey } from '@/service/operate/budgetReport';
export default function useBudgetSurvey(params) {
  var budgetSurvey = ref({
    payImplementRate: 0,
    receiptImplementRate: 0,
    totalActualPay: 0,
    totalActualReceipt: '',
    totalBudgetPay: 0,
    totalBudgetReceipt: 0
  });
  // 查询时间范围内停机详情
  var getBudgetSurveyAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getBudgetSurvey(params.value);
          case 2:
            data = _context.sent;
            if (data) {
              budgetSurvey.value = data;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getBudgetSurveyAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [budgetSurvey, getBudgetSurveyAsync];
}